import { render } from "./GalleryComp.vue?vue&type=template&id=fda4cd54"
import script from "./GalleryComp.vue?vue&type=script&lang=js"
export * from "./GalleryComp.vue?vue&type=script&lang=js"

import "./GalleryComp.vue?vue&type=style&index=0&id=fda4cd54&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__